import React from "react";

function TodosError({ error }) {
    return <p>Desesperate, Hubo un error...;</p>;
}

export { TodosError };